import { useRecoilValue } from 'recoil';
import { useStyles } from '../../../hooks/useStyles';
import { reportSearchTypeState, reportViewState } from '../../../storage/reports';
import { FloatingCardContent } from '../../layout/cards/FloatingCardContent';
import { FloatingCardsLayout } from '../../layout/FloatingCardsLayout';
import StreamingMediaReport from '../../reports/streaming/StreamingMediaReport';
import StreamingMediaReportByGroup from '../../reports/streaming/StreamingMediaReportByGroup';
import ReportsSharedWrapper from './ReportsSharedWrapper';

function EvidencesReportsPage() {
  const { theme } = useStyles();
  const reportView = useRecoilValue(reportViewState);
  const reportSearchType = useRecoilValue(reportSearchTypeState);
  const isGroupReportView = reportSearchType === 1 && reportView === 0;

  return (
    <FloatingCardsLayout
      content={
        <FloatingCardContent
          flexible
          gap={theme.sizing.scale600}
        >
          <ReportsSharedWrapper>
            {!isGroupReportView && <StreamingMediaReport />}
            {isGroupReportView && <StreamingMediaReportByGroup />}
          </ReportsSharedWrapper>
        </FloatingCardContent>
      }
      contentSize={550}
    />
  );
}

export default EvidencesReportsPage;
